import { render, staticRenderFns } from "./ElectronicStatementConsent.vue?vue&type=template&id=17581018&scoped=true"
import script from "./ElectronicStatementConsent.vue?vue&type=script&lang=ts"
export * from "./ElectronicStatementConsent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17581018",
  null
  
)

export default component.exports